import React from "react";
import useTranslate from "../../../core/languages/hooks/useTranslate";
import { Controller, useFormContext } from "react-hook-form";
import LegalCheckModal from "../../../common/components/LegalCheckModal";
import useCustomerContext from "../../../customers/hooks/useCustomerContext";
import TermsAndConditions from "./TermsAndConditions";

interface TransferFooterDetailsProps {
}

const TransferRequestFooterDetails: React.FC<TransferFooterDetailsProps> = () => {
    const t = useTranslate();
    const { control, watch, register, setValue, formState: { errors } } = useFormContext();
    const {customerTranslation} = useCustomerContext();

    return (
        <>
            <div className="space-y-6 mt-8">
                {/* Comments */}
                <div>
                    <Controller
                        name="comments"
                        control={control}
                        render={({ field }) => (
                            <textarea
                                {...field}
                                placeholder={t("transfers.fields.comments") || "Comments"}
                                rows={4}
                                className="w-full px-4 py-3 border border-neutral-200 dark:border-neutral-700 rounded-lg bg-white dark:bg-neutral-900 text-neutral-900 dark:text-white placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        )}
                    />
                </div>
                <TermsAndConditions/>
            </div>

            {customerTranslation?.privacyPolicy && (
                <LegalCheckModal
                    name="privacyPolicy"
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    errors={errors}
                    contentKey={customerTranslation?.privacyPolicy}
                    legalLinkKey="footer.privacyPolicy"
                />
            )}
            {customerTranslation?.contractTerms && (
                <LegalCheckModal
                    name="contractTerms"
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    errors={errors}
                    contentKey={customerTranslation?.contractTerms}
                    legalLinkKey="footer.contractTerms"
                />
            )}
        </>
    );
};

export default TransferRequestFooterDetails;
